export default __webpack_public_path__ + "static/media/DOM-JUNE-2024.2fb2b8b3.png";